// @flow

import type { ICellRendererParams } from "ag-grid-react";

/**
 * iconPlayIndicator
 *
 * A function cell renderer for displaying a 'play button' symbol as svg icon
 *
 * @param {*} params
 */
export default function iconPlay(params: ICellRendererParams) {
  return `<svg class="bi bi-play-fill icon-size-24" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 010 1.393z"/>
      </svg>
  `;
}
